module.exports = __webpack_public_path__ + "img/25.3d94d863.jpg";